import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      { 
        path: "", 
        component: () => import("../views/Home.vue"), 
        meta: { 
          title: "坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "坤和静界是广东省育家心理学研究院旗下专注心理健康服务与艺术疗愈的核心运营品牌，提供疗愈师认证、青少年心理支持、青少年休学服务、企业家心理服务、心理健康科普等全方位心理健康服务。",
          keywords: "心理健康,艺术疗愈,心理咨询,疗愈师认证,青少年心理，青少年休学,企业心理服务,心理培训,广州心理咨询"
        } 
      },
      { 
        path: "about", 
        component: () => import("../views/About.vue"), 
        meta: { 
          title: "关于我们 - 坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "了解坤和静界品牌故事，广东省育家心理学研究院旗下心理健康服务与艺术疗愈品牌",
          keywords: "关于坤和静界,品牌故事,心理健康,艺术疗愈"
        } 
      },
      { 
        path: "services/training", 
        component: () => import("../views/services/Training.vue"), 
        meta: { 
          title: "疗愈师认证 - 坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "坤和静界疗愈师认证培训课程，心理学基础理论、多元疗愈技术实操、个案实践训练",
          keywords: "疗愈师认证,心理培训,心理咨询师认证,心理从业者培训"
        } 
      },
      { 
        path: "services/entrepreneur", 
        component: () => import("../views/services/Entrepreneur.vue"), 
        meta: { 
          title: "躺平计划 - 坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "企业家心理支持服务，帮助企业家提升心力、缓解职场压力、解决心理内耗",
          keywords: "企业家心理服务,躺平计划,职场压力,心理倦怠"
        } 
      },
      { 
        path: "services/youth", 
        component: () => import("../views/services/Youth.vue"), 
        meta: { 
          title: "春藤计划 - 坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "青少年心理支持服务，帮助休学青少年、厌学青少年、抑郁倾向青少年重新看见光",
          keywords: "青少年心理,休学青少年,春藤计划,青少年抑郁,厌学"
        } 
      },
      { 
        path: "services/popularize", 
        component: () => import("../views/services/Popularize.vue"), 
        meta: { 
          title: "心理健康科普 - 坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "坤和静界心理健康科普公益活动，公益讲座、疗愈音乐会、艺术疗愈工作坊",
          keywords: "心理健康科普,公益讲座,疗愈音乐会,艺术疗愈工作坊"
        } 
      },
      { 
        path: "team", 
        component: () => import("../views/Team.vue"), 
        meta: { 
          title: "疗愈师团队 - 坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "坤和静界疗愈师团队，汇聚心理学专家、艺术疗愈师、督导师等专业人士",
          keywords: "疗愈师团队,心理专家,疗愈师,督导师"
        } 
      },
      { 
        path: "contact", 
        component: () => import("../views/Contact.vue"), 
        meta: { 
          title: "联系我们 - 坤和静界艺术疗愈空间 - 心理健康服务与艺术疗愈领导品牌",
          description: "联系我们，坤和静界艺术疗愈空间，广州市海珠区琶洲数字科技产业园",
          keywords: "联系我们,坤和静界地址,广州心理咨询,联系电话"
        } 
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
    scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // 有 hash 就滚动到对应元素
      return {
        selector: to.hash,
        behavior: 'smooth',   // 平滑滚动，不喜欢可以去掉
      };
    }
    // 没有 hash 就回到顶部（相当于你之前的 scrollTop = 0）
    return { x: 0, y: 0 };
  },
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}`;
  }
  if (to.meta.description) {
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = to.meta.description;
  }
  if (to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = to.meta.keywords;
  }
  // setTimeout(() => {
  //   document.documentElement.scrollTop = 0;
  //   document.body.scrollTop = 0;
  //   window.scrollTo(0, 0);
  //   window.pageYOffset = 0;
  // }, 0);
});

export default router;